import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import { API_ROOT } from "../constants/consts";
export function isAbsolutePath(path) {
  return typeof path === 'string' && (path.indexOf('http://') === 0 || path.indexOf('https://') === 0);
}
export function getCorrectURL(path) {
  return isAbsolutePath(path) ? path : "".concat(API_ROOT).concat(path);
}